import { render, staticRenderFns } from "./problem-add.vue?vue&type=template&id=675ea277&scoped=true&"
import script from "./problem-add.vue?vue&type=script&lang=js&"
export * from "./problem-add.vue?vue&type=script&lang=js&"
import style0 from "./problem-add.vue?vue&type=style&index=0&id=675ea277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ea277",
  null
  
)

export default component.exports